import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { useContext, useEffect, useState, Context as ReactContext } from 'react';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { SubscriberRecord } from '../../Common/ConsumerModels/SubscriberRecord';

export function useGetAllSubscribers(shouldReload: boolean) {
  const [subscriberList, setSubscriberList] = useState<SubscriberRecord[]>([]);
  const [subscriberListLoading, setSubscriberListLoading] = useState<boolean>(true);
  const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);
  useEffect(() => {
    /*
      Checking for false boolean because it reloads twice when shouldReload mutates
      false -> true -> false
    */
    if (!shouldReload) {
      setSubscriberListLoading(true);
      httpClient
        .get<SubscriberRecord[]>(`${__API_BASE_URL__}/subscriber/getAllSubscribers`, {
          resource: __CLIENT_ID__,
          headers: {
            'Content-Type': 'application/json',
            'X-Content-Type-Options': 'nosniff',
          },
        })
        .then(({ data }) => {
          setSubscriberList(data);
          setSubscriberListLoading(false);
        });
    }
  }, [shouldReload]);
  return [subscriberList, subscriberListLoading] as const;
}
